import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import type { DraggedCalendarPost } from '../types'

interface TimeSlotProps {
  date: string
  hour: number
  minute?: number
  children?: React.ReactNode
  className?: string
}

export function TimeSlot({ date, hour, minute = 0, children, className = '' }: TimeSlotProps) {
  const { setNodeRef, isOver, active } = useDroppable({
    id: `${date}-${hour}-${minute}`,
    data: { date, hour, minute },
  })

  const activeData = active?.data.current as DraggedCalendarPost | undefined
  const canDrop = activeData
    ? !(
        activeData.currentDate === date &&
        activeData.currentHour === hour &&
        activeData.currentMinute === minute
      )
    : false
  const isActive = isOver && canDrop

  return (
    <div
      ref={setNodeRef}
      className={`group relative h-full min-h-[20px] ${isActive ? 'bg-linear-to-br from-blue-50 to-blue-100/50 ring-2 ring-inset ring-blue-300/50' : ''} ${isOver && !canDrop ? 'bg-linear-to-br from-red-50 to-red-100/50 ring-2 ring-inset ring-red-300/50' : ''} hover:bg-linear-to-br transition-all duration-200 ease-out hover:from-slate-50/50 hover:to-white/50 ${className} `}>
      <div className="bg-size-[20px_20px] absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgb(0_0_0/0.15)_1px,transparent_0)] opacity-0 transition-opacity duration-200 group-hover:opacity-5"></div>

      {isActive && (
        <div className="absolute inset-1 flex items-center justify-center rounded-md border-2 border-dashed border-blue-300 bg-blue-50/30">
          <div className="shadow-xs rounded-full bg-white/80 px-1.5 py-0.5 text-xs font-medium text-blue-600">
            Drop
          </div>
        </div>
      )}

      {children}
    </div>
  )
}
